import axios from "axios";
import _ from "lodash";
import store from "../store/index";
import router from "../router/index";
import service from "./service";
import Vue from "vue";
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import AlertModule from 'vux/src/plugins/alert/module'

import {
getDevice
} from "@/config/utils.js";
import {
goToWechatPage
} from "@/utils/index";
let device = getDevice();
let _this = new Vue();

const generateApiMap = map => {
let facade = {};
_.forEach(map, function (value, key) {
facade[key] = toMethod(value);
});
return facade;
};

const toMethod = options => {
options.method = options.method || "post";
return (params = {}, attachedParams) => {
console.log(attachedParams);


let config = _.merge(options.config, attachedParams);
return sendApiInstance(options.method, options.url, params, config);
};
};


const createApiInstance = (config = {}) => {
let app_token = sessionStorage.getItem("app_token");
const _config = {
withCredentials: false, // 跨域
baseURL: "",
timeout: 100000,
closeLoading: false,
headers: {
"User-Agent-System": device,

clientType: 'tbwxmp',

}
};
if (app_token) {
_config.headers["Authorization"] = app_token;
}
config = _.merge(_config, config);
return axios.create(config);
};

const err_check = (status, message, data) => {
if (status == 1 || status == 6666) {
return true;
}
return false;
};

const sendApiInstance = (method, url, params, config = {}) => {
if (!url) {
return;
}
if (!config.closeLoading) {
_this.$showLoading();
store.commit("showMaskView");
}
config.url = url;
let instance = createApiInstance(config);
instance.interceptors.response.use(
async response => {
let {
status,
msg,
data,
page
} = response.data;
if (err_check(status, msg, data) && data) {
if (!config.closeLoading) {
if (!config.hideMaskView) {
_this.$hideLoading();
store.commit("hideMaskView");
}
}
return {
data: data,
msg: null,
status: status,
page: page
};
} else {
if (!config.closeLoading) {
_this.$hideLoading();
store.commit("hideMaskView");
}

return {
data: null,
msg: msg || "服务异常!",
status: status,
error: response.data.error,
page: page
};
}
},
error => {
console.log("服务异常!");
if (!config.closeLoading) {
_this.$hideLoading();
store.commit("hideMaskView");
}
return {
data: null,
msg: "服务异常!",
status: 0,
type: true,
error: error.response.statusText
};
}
);
if (method === "get" || method === 'delete') {
params = {
params: params
};
}

return instance[method](url, params, config);
};

export default {
generateApiMap
};



// WEBPACK FOOTER //
// ./src/api/apiUtil.js